/**
 * 1 = true, 2 = false
 */
export enum BOOLEAN_ONE {
    "TRUE" = 1,
    "FALSE" = 2
}